export default {"src":"/customer-services/_next/static/media/logo-waitrose-and-partners.a5388b4d.svg","height":61,"width":283,"blurWidth":0,"blurHeight":0};